import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import ScriptBox from './ScriptBox';
import HelpIcon from './HelpIcon';
import SavingIndicator from './SavingIndicator';
import { NavLockIndicator } from '../telephony';
import {
  NavBar,
  SideNav,
  InfoBar,
  BottomNav,
} from './nav';

// utils
import { getSection } from '../../../../utils/form';

import './styles.scss';

function EnrollmentFrame({ children }) {
  const { agentScript } = useSelector(store => store.theme);
  const location = useLocation();
  const section = getSection(location) || {};
  const isTelephonyRoute = section.route.includes('telephony');
  const pageCount = section.pages ? section.pages.length : 0;

  let childrenCols = 'col-md-5';
  let scriptCols = 'col-md-4';
  if (pageCount === 0) {
    scriptCols = 'col-md-12';
  } if (pageCount === 1) {
    childrenCols = 'col-md-6';
    scriptCols = 'col-md-6';
  } if (isTelephonyRoute) {
    childrenCols = 'col-md-8';
    scriptCols = 'col-md-4';
  } if (section.noSideNav && section.noScript) {
    childrenCols = 'col-md-12';
  }

  return (
    <div className="container-fluid min-vh-100 d-flex flex-column">
      <HelpIcon />
      <SavingIndicator />
      <NavLockIndicator />
      <div className="topbar-container">
        <div className="row infobar-container">
          <InfoBar />
        </div>
        <div className="row navbar-container">
          <NavBar />
        </div>
      </div>
      <div className="row navframe-content-container">
        {(pageCount > 1) && !section.noSideNav && (
          <div className="col-md-3 sidenav navframe-content">
            <SideNav />
          </div>
        )}
        {(pageCount > 0) && (
          <div className={`${childrenCols} navframe-fields navframe-content`}>
            {children}
          </div>
        )}
        {agentScript && !section.noScript && (
          <div className={`${scriptCols} ms-auto navframe-script-box navframe-content`}>
            <ScriptBox />
          </div>
        )}
      </div>
      <div className="row bottom-nav-container">
        <BottomNav />
      </div>
    </div>
  );
}

export default EnrollmentFrame;
